import './Link-968346ff.css';

var classes = {"Link":"prc-Link-Link-85e08"};

export { classes as default };
